var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.075,
    y: 130.965,
    width: 468.51,
    height: 314.28,
    rx: 34.029,
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 2.959
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.84,
    cy: 156.445,
    r: 6.896,
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.664,
    cy: 156.445,
    r: 6.896,
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.488,
    cy: 156.445,
    r: 6.896,
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.877 276.111c-5.506-59.549-104.574-58.475-104.574-58.475s-82.476 88.186-101.845 87.26c-19.369-.927 55.796-89.174 55.796-89.174-36.112-9.939-137.548 18.79-137.548 18.79s-14.277 117.139-32.823 111.473c-18.547-5.666 17.933-103.081 17.933-103.081-37.396 4.481-77.787 40.181-77.787 40.181-53.221 60.315 26.979 125.546 26.979 125.546s-5.822 40.489-38.746 82.362c0 0-7.095 7.555-15.327 21.066l9.687 1.687a93.577 93.577 0 0 1 3.939-7.059c.008-.019.012-.029.029-.044.026-.034.038-.063.063-.097.92-1.38 2.254-3.35 3.893-5.732l.004-.01.004-.009c3.966-5.286 6.718-9.215 8.514-12.081l.012-.029c12.037-16.654 28.938-38.132 38.326-41.617 0 0-.812-1.694-1.305-4.803.419 1.531.843 3.131 1.305 4.803 10.401 38.429 92.31 58.781 140.166 57.34 47.856-1.441 29.985-17.977 8.781-43.457-21.205-25.48-74.304-28.974-88.258-39.948-13.955-10.973 9.993-15.348 40.393-7.623 30.387 7.732 40.441 41.214 89.374 54.612 48.933 13.398 103.136-73.611 103.136-73.611-36.216 4.691-94.531-24.995-94.84-37.25-.306-12.264 90.72 4.794 105.55 3.713 14.852-1.082 44.675-25.184 39.169-84.733z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.833 341.689c13.297-21.525 50.63-2.468 50.63-2.468s14.647 48.939 22.16 52.234c7.513 3.295-4.353-44.29-4.353-44.29 15.553 3.032 48.577 33.013 48.577 33.013s-16.643 47.07-8.549 48.415c8.093 1.344 12.611-42.432 12.611-42.432 13.325 8.738 21.908 29.868 21.908 29.868 8.809 32.872-33.857 42.488-33.857 42.488s-5.417 16.437-.825 38.5c0 0 1.266 4.198 1.841 10.867l-3.988-1.185a39.993 39.993 0 0 0-.163-3.416c0-.009.001-.013-.003-.022-.003-.018-.002-.031-.006-.049-.089-.695-.223-1.693-.396-2.904l.001-.005v-.004c-.508-2.75-.811-4.756-.951-6.18l.001-.013c-1.426-8.576-3.786-19.895-6.687-22.983 0 0 .627-.489 1.399-1.575-.447.502-.909 1.028-1.399 1.575-11.175 12.602-46.04 4.893-63.901-4.663-17.861-9.555-7.976-12.456 4.854-18.118 12.831-5.662 33.607 3.011 40.96 1.48 7.353-1.531-.896-7.696-13.869-10.493-12.969-2.791-23.081 8.003-44.143 3.867s-25.219-47.306-25.219-47.306c12.839 8.595 40.522 8.325 42.946 3.741 2.425-4.589-35.275-15.263-40.69-18.464-5.423-3.206-12.186-17.952 1.111-39.478z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.727 304.039c4.238 6.648 15.309 14.395 23.163 14.289 26.751-.49 35.558-18.713 38.445-25.348-.543-.132-1.456-.238-2.105-.318-4.927-.715-9.959-5.588-11.429-11.084-1.894-7.152-4.225-21.137-3.947-30.023l-33.837 18.726c.053 2.569.225 5.377.463 8.211.173 1.722.345 3.417.543 5.059.186 1.576.398 3.072.596 4.45.623 4.635-1.443 9.23-5.35 11.786l-6.542 4.252z",
    fill: "#F8AE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.814 231.199c1.828 4.795 1.06 10.238-.795 15.019-1.311 3.377-4.224.397-7.853.463-5.615.093-9.999-5.748-13.389-21.229-2.159-11.363-2.702-17.124-2.265-18.223 1.55-3.934 6.662-6.039 10.873-6.41",
    fill: "#7E306F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.271 197.15c-8.847 10.661-12.065 40.658-4.595 61.556 5.31 14.859 11.482 24.448 18.686 24.143 10.939-.463 32.142-9.456 39.042-16.965 12.436-13.521 8.82-40.035 6.251-56.722-2.331-15.163-9.43-34.857-28.487-31.109-12.528 2.45-22.964 9.522-30.897 19.097z",
    fill: "#F8AE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.323 208.926c-1.962 2.521-5.421 3.077-8.271 3.575-3.831.67-5.726 2.066-7.715 5.812-1.259 2.392-2.518 5.013-4.771 6.309-1.832 1.058-1.762-1.644-2.057-3.738a4.977 4.977 0 0 0-.112-.542c-.445-1.671-2.225-1.384-2.749.264-.477 1.481-1.498 2.734-2.797 3.432-.212.114-.437.214-.663.171-.305-.042-.543-.327-.742-.584-.417-.538-.832-1.221-1.26-1.945-1.407-2.375-4.062-1.521-5.633.749-.98 1.41-2.147 2.863-3.751 3.19-.517.114-1.166.029-1.405-.47-.305-.612.172-1.225.093-1.851-.066-.584-.318-.841-.597-1.339-1.094-1.938-3.589-2.007-5.126-.399a57.017 57.017 0 0 1-3.344 3.219c-.49.427-1.206.855-1.696.427-.265-.228-.332-.612-.385-.983-.278-1.808-.543-3.617-.821-5.426-.16-1.011-.703-2.336-1.631-2.08-.45.129-.716.599-.967 1.026-.305.541-5.753 6.708-5.859 6.238-.849-3.503-2.585-6.694-3.433-10.198-5.488-22.547 18.862-40.678 37.459-40.778 4.135-.029 7.913.038 11.929.993 4.282 1.025 8.802 2.653 12.685 4.946 5.448 3.205 9.571 9.031 8.51 15.981",
    fill: "#7E306F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.565 201.19c-2.702 3.059-3.417 7.363-3.668 11.429-.371 6.132.132 12.502 2.966 17.945.808 1.549 1.404 9.217 2.649 8.793.397-.132.331-6.078 1.377-9.283 1.616-4.967 9.059-6.86 12.409-3.722 5.351 4.993 2.212 11.059.437 14.833-1.059 2.278-2.741 4.834-3.033 7.244-.357 3.086-.463 14.33 1.55 16.952 1.682 2.198 3.47-8.423 4.993-10.515 11.27-15.588 22.077-55.279 2.834-63.887-2.927-1.311-11.959-1.987-14.7-.318m-79.065 326.041c-1.113.186-2.238.345-3.404.385-6.198.198-12.184-1.166-18.236-2.199-5.324-.914-6.767-1.417-6.661-7.84.927-50.868 8.409-101.604 21.865-150.671 2.052-7.496 4.29-15.045 8.224-21.746 6.714-11.429 22.13-21.295 33.956-26.831 1.669-.782 8.582 3.615 10.264 2.86 1.47-.662 2.768-1.695 4.251-2.344 4.344-1.894 7.257 2.066 10.886 3.722 1.881.847 3.973 1.39 6.039 1.298 1.682-.067 3.205-1.086 4.741-.292 6.913 3.576 24.077-22.964 24.077-22.964l7.456 7.747 21.759 22.792 54.378 74.919s9.866 61.397 16.647 101.644c1.178 6.939 5.84 21.944 6.767 27.202-.198-1.139-46.418-1.444-48.908-1.444h-94.201c-5.284 0-19.494 2.238-23.202-1.642-4.569-4.768-9.854-26.646-10.132-32.778-.914-20.62.504-41.081.782-61.82-.12 8.436-2.543 16.064-3.576 24.328-1.338 10.635-3.245 21.256-4.966 31.837-1.378 8.503-2.702 17.031-3.762 25.587-.476 3.854.133 6.145-3.125 7.655-2.741 1.258-8.714.052-11.919.595z",
    fill: "#7E306F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.264 499.088c2.516-1.033 18.051-4.886 25.056-6.343 3.669-.755 20.303-5.072 24.156-5.072 3.854 0 9.099 5.509 9.099 5.509l-1.391 18.951c-3.708-.37-8.674 1.55-11.336 1.921-2.662.37-11.708.423-17.27-2.371-.318-.159-.609-.331-.9-.503-2.238 1.986-5.046 3.92-8.158 4.079 0 0-2.437-.252-2.199-1.232.106-.477 1.722-2.94 3.338-5.35-2.384 2.423-6.278 6.357-10.767 6.582 0 0-2.437-.252-2.199-1.232.133-.583 2.464-4.066 4.344-6.834-.026.027-.066.04-.079.067-1.974 1.735-6.662 7.721-12.211 7.999 0 0-2.437-.252-2.198-1.232.079-.357 1.006-1.827 2.132-3.536a32.106 32.106 0 0 1-5.258 3.285c-5.999 2.966-9.416.715-9.416 0-.013-.729 12.74-13.655 15.257-14.688z",
    fill: "#F8AE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.283 477.078s-9.668 5.483-8.807 17.137c.861 11.654 4.357 25.163 18.951 23.746 14.595-1.404-10.144-40.883-10.144-40.883z",
    fill: "#7E306F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.072 516.808c34.99 12.145 81.805.543 111.484-19.627 18.594-12.607 30.46-28.619 28.46-44.259-5.178-40.631-37.108-133.759-64.734-147.347-18.779-9.244-41.558-13.072-54.258-14.608-5.96-.728-9.681-.9-9.681-.9l4.608 13.005 23.07 65.052c.861 38.605 28.487 61.529 22.991 70.521-5.496 8.966-48.895 18.647-71.687 33.996-6.304 4.265-14.303 35.109 9.747 44.167z",
    fill: "#7E306F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.022 368.124c-.027 7.324.993 14.661 2.9 21.759 1.92 7.099 4.728 13.945 7.986 20.541 1.629 3.297 3.364 6.529 5.151 9.72 1.762 3.205 3.576 6.384 5.059 9.642.729 1.629 1.365 3.311 1.616 4.966.066.808.133 1.642-.093 2.344-.052.384-.278.675-.41 1.02-.252.304-.424.636-.742.927-2.37 2.37-5.761 3.973-8.979 5.522-13.217 6.026-27.255 10.489-40.631 16.502-6.688 3.006-13.309 6.251-19.468 10.303l-1.139.768c-.384.265-.741.61-1.112.914a10.828 10.828 0 0 0-1.761 2.225c-.981 1.603-1.643 3.351-2.159 5.125-.98 3.563-1.391 7.231-1.417 10.9.238-3.642.847-7.284 1.92-10.741 1.139-3.43 2.9-6.767 6.198-8.37 6.185-3.84 12.82-6.9 19.547-9.72 6.741-2.782 13.562-5.417 20.409-7.973 6.847-2.596 13.733-5.072 20.461-8.145 3.311-1.642 6.714-3.191 9.535-6.039.358-.344.649-.821.954-1.231.225-.504.529-.98.609-1.51.318-1.06.212-2.106.119-3.099-.318-1.96-1.033-3.735-1.801-5.43-1.576-3.39-3.417-6.555-5.205-9.747-1.788-3.192-3.589-6.357-5.297-9.575-6.821-12.82-11.562-26.924-12.25-41.598z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.344 309.058c3.337 3.311 18.196 13.892 32.367 13.892a40.8 40.8 0 0 0 7.482-.702c11.893-2.171 21.905-10.104 27.759-19.189a40.28 40.28 0 0 0 2.821-5.232c1.059-2.277 1.814-4.608 2.251-6.86-5.96-.728-11.654-2.225-12.581-3.284-1.007 6.94-9.575 19.468-22.554 21.825a27.76 27.76 0 0 1-4.635.464h-.027c-6.092.106-10.767-1.841-13.958-3.801-.027 0-6.212-4.874-6.238-4.9l-12.687 7.787z",
    fill: "#7E306F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.019 460.349c.036-.648-.047-1.289-.024-1.938.027-.701.105-1.387.158-2.087l.384-4.011c.247-2.731.494-5.463.7-8.197a333.93 333.93 0 0 0 .837-16.282c.28-10.861.123-21.747-.607-32.585a344.4 344.4 0 0 0-.736-9.088 569.256 569.256 0 0 0-.48-4.656c-.167-1.522-.413-3.034-.433-4.574-.012-.956 1.424-1.021 1.639-.133.634 2.635.727 5.466 1 8.161.259 2.707.491 5.413.697 8.13.395 5.474.657 10.954.786 16.439.234 10.917-.155 21.838-1.086 32.729a265.208 265.208 0 0 1-.939 9.152 187.68 187.68 0 0 1-.62 4.648c-.105.684-.196 1.368-.327 2.037-.163.787-.456 1.513-.62 2.3-.09.181-.351.113-.329-.045z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.067 248.985c-.093 0-.344-.145-.132-.145.105 0 .343.145.132.145z",
    fill: "#CC6144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.171 357.791c5.041 8.904 2.648 22.398 2.648 22.398s-14.424-3.969-19.465-12.874c-5.041-8.905-5.363-18.252-.723-20.884 4.647-2.635 12.499 2.455 17.54 11.36z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.227 285.233c1.226 15.497-10.727 32.542-10.727 32.542s-17.316-14.722-18.543-30.219c-1.226-15.497 4.328-28.575 12.408-29.222 8.09-.646 15.635 11.402 16.862 26.899z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.571 313.732c8.122 6.432 11.02 20 11.02 20s-15.042 1.774-23.164-4.657c-8.121-6.432-11.986-15.076-8.637-19.314 3.356-4.242 12.66-2.46 20.781 3.971z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6 433.563v15.226l13.745 16.382h-57.737c-17.452 0-31.608-14.156-31.608-31.608 0-17.452 14.156-31.608 31.608-31.608h12.384c17.463 0 31.608 14.156 31.608 31.608z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.243 433.509a5.622 5.622 0 0 0 5.619 5.62 5.622 5.622 0 0 0 5.619-5.62 5.622 5.622 0 0 0-5.619-5.619 5.621 5.621 0 0 0-5.619 5.619zm-19.096 0a5.622 5.622 0 0 0 5.62 5.619 5.622 5.622 0 0 0 5.619-5.619 5.622 5.622 0 0 0-5.619-5.619 5.622 5.622 0 0 0-5.62 5.619zm-19.094 0a5.622 5.622 0 0 0 5.619 5.619 5.622 5.622 0 0 0 5.62-5.619 5.622 5.622 0 0 0-5.62-5.619 5.622 5.622 0 0 0-5.619 5.619z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.861 198.953 18.042 43.988a5.885 5.885 0 0 1-3.207 7.68l-76.395 31.331a5.88 5.88 0 0 1-6.614-1.525 5.837 5.837 0 0 1-1.06-1.689l-18.034-43.97a5.875 5.875 0 0 1 3.202-7.672l76.394-31.338c3-1.23 6.423.197 7.672 3.195z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.392 240.869 48.387 5.328a4.442 4.442 0 0 1-2.637 3.087l-76.386 31.336a4.437 4.437 0 0 1-4.023-.336l34.659-39.415z",
    fill: "#E1E4E5",
    stroke: "#fff",
    strokeWidth: 2.882
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.926 234.221v-.001a4.435 4.435 0 0 1 2.415-5.791h.001l76.394-31.338a4.446 4.446 0 0 1 5.469 1.78l-29.498 46.28-54.158-9.414-.623-1.516z",
    fill: "#E1E4E5",
    stroke: "#fff",
    strokeWidth: 2.882
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.71 491.529c-10.433 10.618-29.943 8.38-29.943 8.38s-2.582-19.456 7.861-30.068c10.433-10.619 29.933-8.387 29.933-8.387s2.582 19.456-7.851 30.075z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.445 198.006c3.282 6.012 12.2 7.476 12.2 7.476s3.59-8.287.303-14.298c-3.282-6.013-12.194-7.478-12.194-7.478s-3.591 8.287-.309 14.3z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.172 196.369c6.94-5.996 6.332-18.079 6.332-18.079s-11.86-2.354-18.796 3.648c-6.94 5.996-6.336 18.073-6.336 18.073s11.86 2.354 18.8-3.642z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.96 151.218c2.122-6.102-2.505-13.26-2.505-13.26s-8.065 2.741-10.182 8.846c-2.122 6.103 2.5 13.258 2.5 13.258s8.065-2.741 10.187-8.844z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M721.26 401.858V351.57a4.571 4.571 0 0 0-4.569-4.57h-73.114a4.572 4.572 0 0 0-4.57 4.57v57.242c0 5.198 5.465 8.583 10.119 6.267l15.427-7.675a6.991 6.991 0 0 1 3.083-.733l49.078-.243a4.573 4.573 0 0 0 4.546-4.57z",
    fill: "#f666da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.492 376.06a.908.908 0 1 0 1.284 1.285.908.908 0 0 0-1.284-1.285m16.354 0a.908.908 0 1 0 1.285 1.286.908.908 0 0 0-1.285-1.286m-32.71 0a.908.908 0 1 0 1.284 1.285.908.908 0 0 0-1.284-1.285",
    stroke: "#fff",
    strokeWidth: 9.041,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.45 227.364-9.079 2.506c-9.025 2.491-18.362-2.806-20.853-11.832-2.491-9.026 2.806-18.362 11.832-20.853 9.025-2.491 18.362 2.806 20.853 11.832l.752 2.723a4.71 4.71 0 0 1-9.079 2.506l-.752-2.723a7.535 7.535 0 0 0-9.268-5.259v0a7.535 7.535 0 1 0 9.268 5.259",
    stroke: "#E1E4E5",
    strokeWidth: 4.302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.308 294.811c8.042-5.514 8.829-18.352 8.829-18.352s-12.252-3.89-20.291 1.631c-8.041 5.514-8.832 18.345-8.832 18.345s12.253 3.891 20.294-1.624z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 14.609,
    transform: "matrix(1 0 0 -1 645.616 220.283)",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 8.87,
    transform: "matrix(1 0 0 -1 693.68 306.142)",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m708.289 459.346-13.044-12.522 13.044-12.521 13.043 12.521-13.043 12.522z",
    stroke: "#E1E4E5",
    strokeWidth: 5.308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.713 524.122H270.696l-49.044-121.947h162.777l49.284 121.947z",
    fill: "#f666da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.784 519.375H484.06v4.748H270.697l-1.913-4.748z",
    fill: "#f666da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.628 462.841c-2.091-7.343 2.125-13.296 9.402-13.296 7.277 0 14.86 5.953 16.951 13.296 2.091 7.343-2.125 13.297-9.402 13.297-7.277 0-14.86-5.954-16.951-13.297z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 344.279,
    y1: 762.062,
    x2: 764.926,
    y2: -216.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 287.476,
    y1: 599.905,
    x2: 312.267,
    y2: 150.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 220.53,
    y1: 357.078,
    x2: 168.284,
    y2: 371.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 240.702,
    y1: 292.184,
    x2: 159.55,
    y2: 278.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 316.893,
    y1: 308.354,
    x2: 273.356,
    y2: 341.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 627.084,
    y1: 527.8,
    x2: 702.509,
    y2: 409.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 160.307,
    y1: 219.298,
    x2: 141.798,
    y2: 157.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 719.113,
    y1: 172.205,
    x2: 643.446,
    y2: 213.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 679.054,
    y1: 128.044,
    x2: 647.585,
    y2: 180.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h900v600H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.501c64dc667ae0d8e9771a7fd311d5a0.svg";
export { ForwardRef as ReactComponent };